import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { Store } from '../../defaultState';

import { Config } from 'config/config';
import countriesBlacklist from 'config/countryBlacklist';

export const selectConfig = (state: Store): Config => state.config;
export const selectCountriesBlacklist = () => countriesBlacklist;
export const selectSiteTheme = createDraftSafeSelector(selectConfig, configState => configState.theme);
export const selectCurrentLanguage = createDraftSafeSelector(selectConfig, configState => configState.currentLanguage);
export const userAgentSelector = createDraftSafeSelector(selectConfig, configState => configState.configEnv.userAgent);
export const isCountryBlacklistedSelector = createDraftSafeSelector(
  selectConfig,
  configState => configState.countryBlacklist
);
export const maintenanceSelector = createDraftSafeSelector(selectConfig, configState => configState.maintenance);
export const blacklistCountriesSelector = createDraftSafeSelector(selectCountriesBlacklist, list => {
  return Object.values(list)
    .sort()
    .reduce((p, c, i, arr) => {
      if (arr.length - 1 === i) {
        return p.concat(c);
      } else {
        return p.concat(`${c}, `);
      }
    }, '');
});
